@let state = dialogState$ | async;
@let chipAttachment = chipAttachment$ | async;
@let useVersionNameForAttachment =
    (useVersionNameForAttachment$ | async) ?? false;
@let isOpen = state?.isOpen ?? false;
@let attachment = state?.content?.attachment;
@let canAddVersion = state?.content?.canAddVersion ?? false;
@let canEditPost = state?.content?.canEditPost ?? false;
@let acceptedMimeType = state?.content?.acceptedMimeType ?? undefined;
@let confirmLabel = state?.content?.confirmLabel ?? '';

@if (attachment) {
    <interacta-dialog
        [closeOnBackdropClick]="false"
        [isOpen]="isOpen"
        [size]="'regular'"
        (closing)="attachmentsVersionsService.close()"
    >
        <h2 class="flex typo-t6" title>
            {{
                labelRoot +
                    (canAddVersion && !attachment.isAttachmentRef
                        ? 'MANAGE'
                        : 'CONSULT') | translate
            }}
        </h2>

        @if (canAddVersion || canEditPost) {
            <interacta-dialog-description>
                @if (attachment.isAttachmentRef) {
                    <span>{{
                        labelRoot + 'CONSULT_SUBTITLE_ATTACHMENTS_REF'
                            | translate
                    }}</span>
                    @if (attachment.referencedAttachmentId) {
                        <button
                            class="text-text-primary underline"
                            type="button"
                            (click)="
                                goToAttachments(
                                    attachment.referencedAttachmentId
                                )
                            "
                        >
                            {{
                                labelRoot + 'GO_ORIGINAL_ATTACHMENT' | translate
                            }}
                        </button>
                    }
                } @else {
                    @if (canAddVersion) {
                        <p>{{ labelRoot + 'MANAGE_SUBTITLE' | translate }}</p>
                    } @else if (
                        canEditPost &&
                        (!attachment.drive ||
                            (attachment.drive &&
                                googleAPIService.driveIntegrationEnabled)) &&
                        attachment.post &&
                        attachment.post.id != null
                    ) {
                        <span>{{
                            labelRoot + 'CONSULT_SUBTITLE_1' | translate
                        }}</span>
                        <button
                            class="text-text-primary underline"
                            type="button"
                            (click)="goToPost(attachment.post.id)"
                        >
                            {{ labelRoot + 'CONSULT_SUBTITLE_2' | translate }}
                        </button>
                    }
                }
            </interacta-dialog-description>
        }

        <div class="mt-12 flex flex-col space-y-16 overflow-y-hidden" content>
            @if (canAddVersion) {
                @if (chipAttachment) {
                    <interacta-attachment-chip
                        class="mx-auto w-min max-w-full"
                        [attachment]="chipAttachment"
                        [bgColor]="'surface-B'"
                        [disableHashtagIcon]="true"
                    />
                }

                @if (
                    !attachment.drive &&
                    !newVersionAttachments$.value.length &&
                    !attachment.isAttachmentRef
                ) {
                    <interacta-local-file-select
                        class="block py-4 text-center"
                        [acceptedMimeType]="acceptedMimeType"
                        [disabled]="false"
                        [label]="labelRoot + 'ADD' | translate"
                        [style]="'outlined'"
                        [uploader]="attachmentInputService.uploader"
                    />
                }

                @if (
                    attachment.drive != null &&
                    googleAPIService.driveIntegrationEnabled &&
                    !newVersionAttachments$.value.length &&
                    !attachment.isAttachmentRef
                ) {
                    <interacta-drive-file-select
                        class="block py-4 text-center"
                        [acceptedMimeType]="acceptedMimeType"
                        [label]="'POST_CREATE.ADD_FROM_DRIVE' | translate"
                        [size]="'regular'"
                        [style]="'outlined'"
                        (addDriveAttachments)="addDriveAttachments($event)"
                    />
                }
            }

            @if (attachments$ | async; as versions) {
                <div
                    #container
                    class="flex flex-col space-y-12 overflow-y-auto"
                    [ngClass]="{
                        'pr-8': container.scrollHeight > container.clientHeight,
                    }"
                >
                    @for (
                        version of versions;
                        track trackAttachment($index, version)
                    ) {
                        <interacta-attachment-version
                            [control]="newVersionNameControl"
                            [useVersionNameForAttachment]="
                                useVersionNameForAttachment
                            "
                            [version]="version"
                            (cancelUpload)="cancelUpload(version)"
                            (changeCheck)="changeCheck($event)"
                            (removeVersion)="removeVersion(version)"
                        />
                        @if (canAddVersion) {
                            <interacta-separator [thickness]="'soft'" />
                        }
                    }
                </div>
            }
        </div>

        @if (canAddVersion) {
            <interacta-dialog-buttons>
                <button
                    interacta-dialog-button
                    type="button"
                    [label]="'BUTTON.LABEL_BUTTON_CANCEL' | translate"
                    [style]="'text'"
                    (click)="attachmentsVersionsService.close()"
                ></button>
                <button
                    interacta-dialog-button
                    type="button"
                    [disabled]="isLoadingAttachment()"
                    [label]="
                        (newVersionAttachments$.value.length
                            ? confirmLabel
                            : 'UI.BUTTON.CLOSE'
                        ) | translate
                    "
                    [style]="'filled'"
                    (click)="save(attachment)"
                ></button>
            </interacta-dialog-buttons>
        }
    </interacta-dialog>
}
